/**
 * Centralized Subscription Configuration
 * CHANGE THIS VALUE TO UPDATE PRICING EVERYWHERE IN THE FRONTEND
 */

export const SUBSCRIPTION_CONFIG = {
  // Annual subscription price in dollars
  ANNUAL_PRICE_DOLLARS: 350,
  
  // Computed values
  get ANNUAL_PRICE_CENTS() {
    return this.ANNUAL_PRICE_DOLLARS * 100
  },
  
  get ANNUAL_PRICE_FORMATTED() {
    return `$${this.ANNUAL_PRICE_DOLLARS}/year`
  },
  
  // Billing cycle
  BILLING_CYCLE: 'annual' as const,
  
  // Discount vouchers
  VOUCHER_TYPES: ['25%', '50%', '75%', '100%', 'forever-free'] as const,
} as const

// Export for convenience
export const ANNUAL_SUBSCRIPTION_PRICE = SUBSCRIPTION_CONFIG.ANNUAL_PRICE_DOLLARS
export const ANNUAL_SUBSCRIPTION_PRICE_DISPLAY = SUBSCRIPTION_CONFIG.ANNUAL_PRICE_FORMATTED

